import { useState, useCallback } from "react";

import { api } from "~/api";
import type { Cluster } from "~/types";

export function useGitRefresh() {
  const [isRefreshing, setIsRefreshing] = useState(false);

  const refresh = useCallback(async (): Promise<Cluster[]> => {
    setIsRefreshing(true);
    try {
      return await api.refreshGitCache();
    } catch (error) {
      console.error("Failed to refresh git cache:", error);
      return [];
    } finally {
      setIsRefreshing(false);
    }
  }, []);

  return { isRefreshing, refresh };
}
